import { Centered } from '@studio/design-system/overlay';
import { clsx } from 'cn';

/** Colors component. */
export const Colors = () => (
  <Centered>
    <div className='grid grid-cols-3 gap-12'>
      {[
        'bg-accent',
        'bg-base-50',
        'bg-base-100',
        'bg-base-200',
        'bg-base-300',
        'bg-black',
        'bg-white',
        'bg-dark',
        'bg-error',
        'bg-error-highlight',
        'bg-focus',
        'bg-foreground',
        'bg-inherit',
        'bg-light',
        'bg-muted',
        'bg-primary',
        'bg-primary-highlight',
        'bg-secondary',
        'bg-success',
        'bg-success-highlight',
        'bg-transparent',
        'bg-warning',
        'bg-warning'
      ].map((color) => (
        <div className={clsx(color, 'flex items-center justify-center p-28 font-bold')} key={color}>
          <div className='bg-black p-4 text-md'>{color}</div>
        </div>
      ))}
    </div>
  </Centered>
);
